import { useMutation } from '@tanstack/react-query';
import apiClient from '@/services/api';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

interface ResendApiData {
  sent: boolean;
}

export type ResendStatus = 'idle' | 'sending' | 'sent' | 'error';

/** Single source for "resend the email verification link" (POST /api/auth/resend-verification). */
export const useResendVerification = () => {
  const mutation = useMutation({
    mutationFn: async (): Promise<boolean> => {
      const res = await apiClient.post<ApiResponse<ResendApiData>>('/api/auth/resend-verification');
      return res.data.data.sent;
    },
  });
  const status: ResendStatus = mutation.isPending
    ? 'sending'
    : mutation.isSuccess
      ? 'sent'
      : mutation.isError
        ? 'error'
        : 'idle';
  return { status, resend: () => mutation.mutate() };
};
